import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseConfig";

export type CollectionFilters = { kioskIds?: string[]; ownerIds?: string[] };
export type HistoryCursor = { timestamp: number; id: string; source: "receipt" | "empty" };
export type HistoryRequest = CollectionFilters & {
    kioskId?: string;
    scope?: "current" | "all";
    cycleId?: string | null;
    date?: string;
    cursor?: HistoryCursor | null;
};
export type CollectionRow = {
    id: string;
    source: "receipt" | "empty";
    kiosk: string;
    owner: string;
    type: "DEPOSIT" | "DONATE" | "EMPTY";
    inputAmt: number;
    timestamp: number;
};
export type HistoryPage = {
    rows: CollectionRow[];
    cursor: HistoryCursor | null;
    hasMore: boolean;
    currentAvailable: boolean;
    currentBasis?: "legacy" | "collection" | null;
    cycleId?: string | null;
    lastEmptiedAt?: number | null;
};
export type CollectionStats = {
    days: { date: string; count: number; quantity: number }[];
    count: number;
    quantity: number;
};

export const readCollectionHistory = async (request: HistoryRequest) =>
    (await httpsCallable<HistoryRequest, HistoryPage>(functions, "getCollectionHistory")(request)).data;

export const readCollectionStats = async (request: CollectionFilters & { startDate: string; endDate: string }) =>
    (await httpsCallable<typeof request, CollectionStats>(functions, "getCollectionStats", { timeout: 120000 })(request)).data;

export const collectionErrorMessage = (error: unknown) => {
    const message = error instanceof Error ? error.message : "";
    if (message.includes("cycle-changed")) return "수거가 처리되어 조회 구간이 바뀌었습니다. 모달을 닫았다가 다시 열어주세요.";
    if (message.includes("invalid-date-range")) return "시작일을 종료일 이전으로 설정해주세요.";
    if (message.includes("narrow-date-range")) return "조회할 기록이 많습니다. 기간이나 대상을 줄여주세요.";
    return "내역을 불러오지 못했습니다. 다시 시도해주세요.";
};
